import { Button, Grid, Paper } from "@mui/material";

import { useEffect, useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { gridSize, gridSizeMdLg4, texto, TipoProductoEnumChoice, useTableColumnsProducto, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { CustomAutocomplete, CustomTextFieldNoForm, GeneralTable, SearchComponente, } from "@/shared/components/ui";
import { CATEGORYPRODUCT } from "@/shared/interfaces/erp/inventario";
import { getUbicacionProductoSimple, useFetchCategoryProduct, useFetchProductoSimple } from "@/shared/actions/erp";

import { useForm } from "react-hook-form";
import { AlertSeverityEnum, IDataProducto } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import AddCircleIcon from '@mui/icons-material/AddCircle';


type ModalProductoComponenteProps = {
  onChange: (e: IDataProducto) => void,
  ubicacion: string | null;
}
export default function ModalProductoComponente({ onChange, ubicacion }: ModalProductoComponenteProps) {
  //console.log('ubicacion',ubicacion)
  //state
  const [isOpenModalProducto, setIsOpenModalProducto] = useState(false)
  const [selectProductoCategoria, setSelectCategoria] = useState<string | null>(null)
  //const [/* selectGrupoCatalogo, */ setSelectGrupoCatalogo] = useState<string | null>(null)
  const { columnsSelectProductoModal } = useTableColumnsProducto()
  const setAlert = useUiStore(s => s.setAlert)
  //hook
  const form = useForm();
  const { } = form

  const {
    pagination,
    setPagination,
    globalFilter,
    setGlobalFilter,
    onChangeFilter,
    searchTerm,
    cleanFilter,
  } = useTableFilter()
  const { pageIndex, pageSize } = pagination

  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()

  //FETCH
  const { data: CategoriaProductosPaging, isLoading: isLoadingCategoriaProductos } =
    useFetchCategoryProduct({
      page_size: 600,
    });


  const { data: dataProductos, isLoading: isLoadingProductos, isRefetching: isRefetchingProducto
    //} = useFetchProductos({
  } = useFetchProductoSimple({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      tipo_producto: TipoProductoEnumChoice.INVENTARIABLE,
      descripcion: searchTerm.toUpperCase(),
      estado:true,
      ...filterObject,
      filterByState: false,
      ...(selectProductoCategoria ? { categoria_producto: selectProductoCategoria } : {})
    },
    //enabled: selectProductoCategoria !== null
  })
  const opcionTodos = { codigo: "", nombre: "- TODOS -", }
  //const opcionVacia={''}

  const categorias = CategoriaProductosPaging?.data.data || []
  // El array que pasamos al Autocomplete
  const opcionesCategoria = [opcionTodos, ...categorias]

  //* barrido para capturar el codigo de stock actual
  /* const ubiProductoStock = async (codigo: string) => {
    const resp = await getUbicacionProducto({
      page_size: 600,
      productos: codigo,
      //producto: codigo,
      ubicacion: ubicacion,
    });
    if (resp && resp.data.data.length > 0) {
      return resp?.data?.data[0]?.stock
    } else {
      return 0;
    }
  } */

  const ubicacionProducto = async (codigo: string) => {
    const resp = await getUbicacionProductoSimple({
      page_size: 600,
      productos: codigo,
      //producto: codigo,
      ubicacion: ubicacion,
    });
    if (resp && resp.data.data.length > 0) {
      return resp?.data?.data[0]
    } else {
      return null;
    }

  }

  //*
  const onChangeAux = async (e: IDataProducto) => {
    //const stockActual = await ubiProductoStock(e.codigo)
    const dataUbicacionProd = await ubicacionProducto(e.codigo)

    const auxProducto = {
      ...e,
      stockActual: dataUbicacionProd?.stock ?? 0,
      id: e.id_producto,
      //usa_metros: dataUbicacionProd?.usa_metros,
      metros_actuales: dataUbicacionProd?.metros_actuales,
    }

    onChange(auxProducto as any)
  }
  //limpiar
  useEffect(() => {
    if (!isOpenModalProducto) {
      /*    setSelectGrupoCatalogo(null) */
      setSelectCategoria(null)
      form.setValue("tipo_producto", "")
      form.setValue("categoria_producto", "")
      setGlobalFilter('')
      cleanFilter()
    }
  }, [isOpenModalProducto])

  return (
    <>
      <Button
        variant="contained"
        endIcon={<AddCircleIcon />}
        onClick={() => {
          if (!ubicacion) {
            setAlert(true, 'Seleccionar una ubicacion para la solicitud.', AlertSeverityEnum.info)
            return;
          }

          setIsOpenModalProducto(true)
        }}
      >
        Agregar Items
      </Button>

      <ScrollableDialogProps
        open={isOpenModalProducto}
        title="Productos"
        onCloseIcon={() => setIsOpenModalProducto(false)}
        minWidth="70%"
        contentNode={
          <>
            <Grid item {...gridSize}>
              <Paper className="paper-producto">
                <Grid container spacing={2} alignItems={"center"}>
                  <Grid item {...gridSizeMdLg4}>
                    <SearchComponente
                      value={globalFilter}
                      //text="por codigo"
                      text="por Descripción"
                      onChange={onChangeFilter}
                    />

                  </Grid>

                  <Grid item {...gridSizeMdLg4}>
                    <CustomTextFieldNoForm
                      label="Tipo producto"
                      defaultValue={TipoProductoEnumChoice.INVENTARIABLE}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item {...gridSizeMdLg4}>
                    <CustomAutocomplete<CATEGORYPRODUCT | { nombre: string, codigo: string }>
                      label={texto.categoria_producto}
                      name="categoria_producto"
                      options={opcionesCategoria}
                      //options={CategoriaProductosPaging?.data.data || []}
                      isLoadingData={isLoadingCategoriaProductos}
                      valueKey="nombre"
                      actualValueKey="codigo"
                      defaultValue={''}
                      control={form.control}
                      error={undefined}
                      helperText={undefined}
                      onChangeValue={(e) => {
                        setSelectCategoria(e)
                      }
                      }
                    />
                  </Grid>
                  <div className="linea" />
                  <Grid item xs={12}>

                    {/*  ***** LE COMENTO ESTO PORQUE NO QUIERE QUE MUESTRE A LOS PRODUCTOS CUANDO 
                        ****** SELECCIONE GRUPO CATLOGO
                   {!selectGrupoCatalogo && !form.getValues().tipo_producto && (
                      <Grid item>
                        <TabTextLabel
                          text={"Seleccione la opción Grupo Catálogo para cargar el producto"}
                          mt={0}
                          pb={1}
                          pl={0}
                          pt={1}
                        />
                      </Grid>
                    )} */}

                    {/* (selectProductoCategoria !== null) && ( */
                      <GeneralTable
                        columns={columnsSelectProductoModal}
                        data={dataProductos?.data.data || []}
                        isLoading={isLoadingProductos}
                        isRefetching={isRefetchingProducto}
                        enableGlobalFilter={false}
                        //
                        pagination={pagination}
                        onPaging={setPagination}
                        rowCount={dataProductos?.data.count}
                        //* filter - server side
                        columnFilters={columnFilters}
                        onColumnFiltersChange={setColumnFilters}
                        enableManualFiltering={true}
                        enableSorting={false}
                        //
                        canEdit={false}
                        enableColumnActions={true}
                        canAdd={true}
                        onAdd={e => {                          
                          onChangeAux(e)
                        }}
                      />
                      /* ) */
                    }

                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </>
        }
      />
    </>
  )
}